export default __webpack_public_path__ + "maps-overview-header-image-960-fd33c96c5e8c0874ca8c98cebfd388e5.webp";